import { useState, useCallback, createContext, useContext } from 'react';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="toast-container">
        {toasts.map((toast) => (
          <div key={toast.id} className={`toast toast-${toast.type}`}>
            {toast.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) throw new Error('useToast must be used within ToastProvider');
  return context;
};

// Exportación directa para uso sin hooks (útil en algunos casos)
export const toast = {
  success: (msg) => window._toast?.addToast?.(msg, 'success'),
  error: (msg) => window._toast?.addToast?.(msg, 'error'),
  info: (msg) => window._toast?.addToast?.(msg, 'info'),
  warning: (msg) => window._toast?.addToast?.(msg, 'warning'),
};

// Patch global para uso fuera de hooks
if (typeof window !== 'undefined') window._toast = { addToast: null };
